<template>
  <section class="ipad-prompt">
    <h2>Tap the option that matches what you have</h2>
    <div class="keyboard-choice-wrapper">
      <div>
        <a @click="chooseExternalKeyboard(false)">
          <img :src="iPadHands" />
        </a>
        <span>Just the iPad</span>
      </div>
      <div>
        <a @click="chooseExternalKeyboard(true)">
          <img :src="keyboardHands" />
        </a>
        <span>Separate keyboard and iPad</span>
      </div>
    </div>
  </section>
</template>

<script>
import { mapMutations } from 'vuex';
import iPadHands from 'images/iPadHands.jpg';
import keyboardHands from 'images/KeyboardHands.jpg';

export default {
  name: 'keyboardSelect',

  data() {
    return {
      previousPath: '',
      iPadHands,
      keyboardHands
    };
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.previousPath = from.fullPath; // eslint-disable-line no-param-reassign
    });
  },

  methods: {
    ...mapMutations('application', ['chooseMobileKeyboard']),

    chooseExternalKeyboard(choseExtKey) {
      // eslint-disable-next-line
      const redirectTo = {
        path: this.$router.app._route.query.return,
        query: this.$router.app._route.query.query
      };

      this.chooseMobileKeyboard(choseExtKey);
      this.$router.replace(redirectTo);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/sass/_vars.scss';

.ipad-prompt {
  &,
  h2 {
    font-family: 'hwtfutura-semibold';
  }
  z-index: 1000;
  position: absolute;
  background-color: $kwtYellow;
  height: 100%;
  top: 0;
  right: 0;
  width: 100%;
  text-align: center;
  overflow-y: auto;
  h2 {
    margin: 75px 0;
  }
  .keyboard-choice-wrapper {
    display: flex;
    justify-content: space-around;
    div {
      text-align: center;
      display: flex;
      flex-direction: column;
    }
  }
}
</style>
